const RESET_THEME = 'theme/RESET_THEME';

const GET_FIREBOARD_THEME_REQUESTED = 'fireboardTheme/GET_FIREBOARD_THEME_REQUESTED';
const GET_FIREBOARD_THEME_SUCCESS = 'fireboardTheme/GET_FIREBOARD_THEME_SUCCESS';
const GET_FIREBOARD_THEME_FAILURE = 'fireboardTheme/GET_FIREBOARD_THEME_FAILURE';

const UPDATE_FIREBOARD_THEME_REQUESTED = 'fireboardTheme/UPDATE_FIREBOARD_THEME_REQUESTED';
const UPDATE_FIREBOARD_THEME_SUCCESS = 'fireboardTheme/UPDATE_FIREBOARD_THEME_SUCCESS';
const UPDATE_FIREBOARD_THEME_FAILURE = 'fireboardTheme/UPDATE_FIREBOARD_THEME_FAILURE';

const GET_FIREBOARD_CUSTOMIZATIONS_LABELS_REQUESTED = 'fireboardTheme/GET_FIREBOARD_CUSTOMIZATIONS_LABELS_REQUESTED';
const GET_FIREBOARD_CUSTOMIZATIONS_LABELS_SUCCESS = 'fireboardTheme/GET_FIREBOARD_CUSTOMIZATIONS_LABELS_SUCCESS';
const GET_FIREBOARD_CUSTOMIZATIONS_LABELS_FAILURE = 'fireboardTheme/GET_FIREBOARD_CUSTOMIZATIONS_LABELS_FAILURE';

const SAVE_FIREBOARD_CUSTOMIZATIONS_LABELS_REQUESTED = 'fireboardTheme/SAVE_FIREBOARD_CUSTOMIZATIONS_LABELS_REQUESTED';
const SAVE_FIREBOARD_CUSTOMIZATIONS_LABELS_SUCCESS = 'fireboardTheme/SAVE_FIREBOARD_CUSTOMIZATIONS_LABELS_SUCCESS';
const SAVE_FIREBOARD_CUSTOMIZATIONS_LABELS_FAILURE = 'fireboardTheme/SAVE_FIREBOARD_CUSTOMIZATIONS_LABELS_FAILURE';

const initialState = {
  loading: false,
  loaded: false,
  error: false,
  styleCssURL: null,
  fireboardThemeData: null,
  fireboardCustomizationLabels: null
};

export default(state = initialState, action) => {
  switch (action.type) {
    case GET_FIREBOARD_THEME_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case GET_FIREBOARD_THEME_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        fireboardThemeData: action.result,
      };
    }
    case GET_FIREBOARD_THEME_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
        fireboardThemeData: null,
      };
    }
    case UPDATE_FIREBOARD_THEME_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case UPDATE_FIREBOARD_THEME_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
      };
    }
    case UPDATE_FIREBOARD_THEME_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
      };
    }
    case GET_FIREBOARD_CUSTOMIZATIONS_LABELS_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case GET_FIREBOARD_CUSTOMIZATIONS_LABELS_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        fireboardCustomizationLabels: action.result,
      };
    }
    case GET_FIREBOARD_CUSTOMIZATIONS_LABELS_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
        brandCustomizationsLabels: null,
      };
    }
    case SAVE_FIREBOARD_CUSTOMIZATIONS_LABELS_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case SAVE_FIREBOARD_CUSTOMIZATIONS_LABELS_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
      };
    }
    case SAVE_FIREBOARD_CUSTOMIZATIONS_LABELS_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
      };
    }

    case RESET_THEME: {
      return {
        ...state,
        styleCssURL: null,
      };
    }
    default: return state;
  }
};

export const resetThemeURL = () => {
  return {
    type: RESET_THEME
  };
};

export const getFireboardTheme = (brandId) => {
  return {
    types: [GET_FIREBOARD_THEME_REQUESTED, GET_FIREBOARD_THEME_SUCCESS, GET_FIREBOARD_THEME_FAILURE],
    promise: client => client.get(`getFireboardTheme/${brandId}`)
  };
};

export const updateFireboardTheme = (data) => {
  return {
    types: [UPDATE_FIREBOARD_THEME_REQUESTED, UPDATE_FIREBOARD_THEME_SUCCESS, UPDATE_FIREBOARD_THEME_FAILURE],
    promise: client => client.post('updateFireboardTheme', { data })
  };
};

export const getFireboardCustomizationsLabels = (brandId, languageId) => {
  return {
    types: [GET_FIREBOARD_CUSTOMIZATIONS_LABELS_REQUESTED, GET_FIREBOARD_CUSTOMIZATIONS_LABELS_SUCCESS, GET_FIREBOARD_CUSTOMIZATIONS_LABELS_FAILURE],
    promise: client => client.get(`getFireboardCustomizationLabels/${brandId}/languageId/${languageId}`)
  };
};

export const saveFireBoardCustomizationsLabels = (data) => {
  return {
    types: [SAVE_FIREBOARD_CUSTOMIZATIONS_LABELS_REQUESTED, SAVE_FIREBOARD_CUSTOMIZATIONS_LABELS_SUCCESS, SAVE_FIREBOARD_CUSTOMIZATIONS_LABELS_FAILURE],
    promise: client => client.post('saveFireboardCustomizationLabels', { data })
  };
};
